export const GOODS_SORTNIG_TYPES = {
  "0": "FirstNew",
  "1": "FirstCheap",
  "2": "FirstExpensive",
  "3": "FirstWithDiscount"
}

export const GOODS_OFFSET = 9